import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthService } from '@app/core/auth.service';
import { AuthGuardService } from './auth-guard.service';

import { HeaderComponent } from './header/header.component';
import { HttpCacheService } from './http-cache.service';
import { LogoService } from './logo.service';
import { NavbarComponent } from './navbar/navbar.component';
import { ServiceFactory } from './services/service.factory';
import { WindowService } from './window.service';

@NgModule({
  declarations: [HeaderComponent, NavbarComponent],
  exports: [HeaderComponent, NavbarComponent],
  imports: [CommonModule],
  providers: [
    AuthService,
    HttpCacheService,
    AuthGuardService,
    LogoService,
    {
      provide: WindowService,
      useFactory: () => window,
    },
    ServiceFactory,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule.');
    }
  }
}
